import { render, staticRenderFns } from "./AmendedPlanHistory.vue?vue&type=template&id=083d88ec&scoped=true"
import script from "./AmendedPlanHistory.vue?vue&type=script&lang=js"
export * from "./AmendedPlanHistory.vue?vue&type=script&lang=js"
import style0 from "./AmendedPlanHistory.vue?vue&type=style&index=0&id=083d88ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083d88ec",
  null
  
)

export default component.exports